import { newDirectoryGroupAccesses } from "@p0security/shared/integrations/directories/accesses";
import { groupOnlyFilters } from "@p0security/shared/integrations/directories/filters";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import { Registration } from "@p0security/shared/integrations/types";

import { OktaComponents } from "./components.ts";

export const OktaRegistration = Registration({
  accesses: newDirectoryGroupAccesses("ga"),
  category: "directory",
  components: OktaComponents,
  docs: { install: "okta" },
  filters: groupOnlyFilters,
  itemKind: "directory",
  label: "Okta",
  logoUrl: "https://www.okta.com/favicon.ico",
  maturity: "ga",
  requestType: "requestable",
  useMapping: [],
});

registerIntegration("okta", OktaRegistration);
